// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__1XGyI","radioRow":"SimpleQuestionBuilderModal_radioRow__3XU85"};